<template>
  <div class="grid fx_ctr h__fixed scrollable">
    <div class="listcon mcol h__fixed spacing scroll__y">
      <Postbox />
      <List :status="2" />
    </div>
    <div class="stage mcon h__fixed">
      <Pot />
    </div>
  </div>
</template>

<script>
import List from '@/components/List.vue';
import Pot from '@/components/Pot.vue';
import Postbox from '@/components/Postbox.vue';

export default {
  name: 'Archived',
  components: {
    List,
    Pot,
    Postbox
  }
}
</script>
